import React from "react";

/**
 * Circular progress ring. status: 'uploading' | 'success' | 'retry' | 'error'
 * progress: 0..100
 */
export default function UploadProgress({ progress = 0, status = "uploading", size = 36 }) {
  const stroke = 4;
  const r = (size - stroke) / 2;
  const C = 2 * Math.PI * r;
  let dash = C * (1 - Math.max(0, Math.min(100, progress)) / 100);
  let color = "#002FA7";
  if (status === "success") { dash = 0; color = "#00C853"; }
  if (status === "error") color = "#FF2A2A";
  if (status === "retry") color = "#FFD700";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="upload-progress">
      <svg width={size} height={size} className={status === "retry" ? "animate-spin" : ""} style={{ animationDuration: "1.6s" }}>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#000" strokeOpacity="0.1" strokeWidth={stroke} fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r}
          stroke={color} strokeWidth={stroke} fill="none"
          strokeLinecap="square"
          strokeDasharray={C}
          strokeDashoffset={dash}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 240ms ease" }} />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center font-mono text-[9px] font-bold">
        {status === "success" ? "✓" : status === "error" ? "!" : `${Math.round(progress)}%`}
      </div>
    </div>
  );
}
